export enum UserBadgeType {
  DO_GOODER = 'do-gooder.svg',
}
